import type {UseFilterParams} from '@/modules/common/hooks/useFilterParams';
import type {Price} from '@/redux/v1/models';

import {config} from '@/config';
import {FILTER_PRICE} from '@/modules/common/models/filters';

type Props = {
  filterParams: UseFilterParams;
  priceMin?: Price | null;
};

type Value = [Price | null, Price | null];

export const usePriceFilter = ({
  filterParams: [filterParams, setFilterParams],
  priceMin,
}: Props) => {
  const {priceMinEnabled} = config.filters.price;

  let rangeValue: Value = [null, filterParams.priceMax];
  if (priceMinEnabled) {
    rangeValue = [filterParams.priceMin, filterParams.priceMax];
  } else if (filterParams.priceMax == null) {
    rangeValue = [null, null];
  }

  return {
    id: FILTER_PRICE,
    title: '',
    available: true,
    active: rangeValue[0] != null || rangeValue[1] != null,
    value: rangeValue,
    priceMin,
    setValue: (value: Value) => {
      setFilterParams((previous) => ({
        ...previous,
        priceMin: value[0],
        priceMax: value[1],
      }));
    },
    clear: () => {
      setFilterParams((previous) => ({
        ...previous,
        priceMax: null,
        priceMin: null,
      }));
    },
  };
};
